<template>
  <div id="topbar">
    <slot name="topbar"></slot>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin'

export default {
  name: "Topbar",
  props: {},
  components: {},
  mixins: [
    store,
  ],
  data() {
    return {};
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {},
  computed: {}
};
</script>
<style lang="scss">
#topbar {
  height: 40px;
  background: #222;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  font-size: 14px;
  color: white;

  #main-nav {
    height: 100%;
    display: flex;
    align-items: center;
    gap: 20px;
    width: 380px;
    border-right: 1px solid #595959;

  }

  .nav-item {
    height: 100%;
    align-items: center;
    display: flex;
    gap: 10px;
    border-bottom: 3px solid transparent;
    padding: 3px 10px 0 10px;
    cursor: pointer;
  }

  .active {
    border-bottom: 3px solid #1266F1;
  }

  .nav-item-file-auto {
    width: auto !important;
    min-width: auto !important;
  }

  .nav-item-file {
    white-space: nowrap;
    cursor: default;
    overflow: hidden;
    padding: 0 20px;
    border-right: 1px solid #595959;
    gap: 20px;
    cursor: pointer;

    .file-text {
      max-width: 150px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    &.exact-active {
      height: 40px !important;
      padding-bottom: 1px;
      border-bottom: 0 !important;
      background: #2C2C2C;

      &:hover {
      }
    }

    &.active {
      border-bottom: 0 !important;
      background: #1266F1;

      &:hover {
        background: #1266F1 !important;
      }
    }
  }

  .open-files-nav {
    display: flex;
  }

  .open-files-nav .nav-item-file {
    border-bottom: 0px solid #595959;
    height: 100%;
    display: flex;
    align-items: center;
    min-width: 255px;
    justify-content: space-between;

    &:hover {
      background: #2C2C2C;
    }
  }

  .open-files-nav > :first-child {
    border-left: 0px solid #595959 !important;
  }

  .active {
    border-bottom: 3px solid #1266F1;
  }
}

#topbar-left {
  display: flex;
  width: 100%;
  overflow: hidden;
}
</style>
